(() => {
    $(document).on('click', '.selector-label-wrap', function () {
        $(this).find('.label-wrap').removeClass('ext').addClass('bg-hover')
        $(this).addClass('open').siblings().removeClass('open').find('.label-wrap').removeClass('bg-hover').addClass('ext')
        $('.circle-cursor.circle-cursor--inner, .circle-cursor.circle-cursor--outer').removeClass('ext-hover').addClass('sq-hover')
    })

    // $(document).on('mouseover', '.option-wrap', function () {
    //     $(this).prev('.selector-label-wrap').addClass('open')
    // })

    // $(document).on('mouseleave', '.selector-label-wrap, .option-wrap', function (e) {
    //     $('.selector-label-wrap').removeClass('open')
    // })

    $(document).on('click', '.option-wrap .btn-close p', function () {
        $('.selector-label-wrap').removeClass('open').find('.label-wrap').removeClass('bg-hover').addClass('ext')
    })

    $(document).on('click', '.selector-row-wrap h6.title', function () {
        if (!$(this).data('islink')) {
            return
        }
        const title = encodeURIComponent($(this).text().trim())
        redirect(title)
    })

    $(document).on('click', '.selector-row-wrap .desc-wrap p', function () {
        const title = encodeURIComponent($(this).text().trim())
        redirect(title)
    })

    function redirect (title) {
        const baseUrl = location.origin + location.pathname
        location.href = `${baseUrl}?filter=${title}`
    }
})()
